<template>
  <section>
    <div class="generated-report-list">
      <GeneratedReportsList :reports="getUserGeneratedReports" @refresh="refresh" />
    </div>
  </section>
</template>
<script>
import { ReportsGetters, ReportsActions } from '../reports.keys';
import GeneratedReportsList from './GeneratedReportsList.vue';
export default {
  name: 'GeneratedReportsListing',
  components: {
    GeneratedReportsList
  },
  data() {
    return {
      report: []
    };
  },
  computed: {
    getUserGeneratedReports() {
      return this.$store.getters[ReportsGetters.UserGeneratedReport];
    }
  },
  mounted() {
    this.$store.dispatch(ReportsActions.RetrieveUserGeneratedReport);
  },
  methods: {
    refresh() {
      this.$store.dispatch(ReportsActions.RetrieveUserGeneratedReport);
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.generated-report-list {
  height: 50%;
}
</style>
